export type JwtClaims = {
    sub?: string;
    org_id?: string;
    role?: string;
    role_id?: string;
    perm_ver?: number;
    exp?: number;
    iat?: number;
    jti?: string;
    [key: string]: unknown;
};

function base64UrlToBase64(input: string): string {
    const normalized = String(input || '').replace(/-/g, '+').replace(/_/g, '/');
    const padLen = (4 - (normalized.length % 4)) % 4;
    return normalized + '='.repeat(padLen);
}

function decodeBase64UrlJson<T>(part: string): T | null {
    try {
        const base64 = base64UrlToBase64(part);
        const anyGlobal = globalThis as any;
        const json =
            typeof anyGlobal?.atob === 'function'
                ? anyGlobal.atob(base64)
                : typeof anyGlobal?.Buffer !== 'undefined'
                    ? anyGlobal.Buffer.from(base64, 'base64').toString('utf8')
                    : null;
        if (!json) return null;
        return JSON.parse(json) as T;
    } catch {
        return null;
    }
}

export function decodeJwtClaims(token: string | null | undefined): JwtClaims | null {
    const raw = String(token || '').trim();
    if (!raw) return null;
    const parts = raw.split('.');
    if (parts.length < 2) return null;
    return decodeBase64UrlJson<JwtClaims>(parts[1]);
}

export function isJwtExpired(claims: JwtClaims | null | undefined, skewSeconds = 30): boolean {
    const exp = typeof claims?.exp === 'number' ? claims.exp : null;
    if (!exp) return true;
    const now = Math.floor(Date.now() / 1000);
    return now >= exp - Math.max(0, skewSeconds);
}

export function secondsUntilExpiry(claims: JwtClaims | null | undefined): number | null {
    const exp = typeof claims?.exp === 'number' ? claims.exp : null;
    if (!exp) return null;
    const now = Math.floor(Date.now() / 1000);
    return exp - now;
}
